import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const PrimaryButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
 // const baseClass = !other.notsetbackcolorwhenfocus ? 'ifms-primary-button' : 'ifms-primary-button b';

  let baseClass = 'ifms-primary-button';

  if (other.notsetbackcolorwhenfocus === 'b') {
      baseClass = 'ifms-primary-button b';
  } else if (other.notsetbackcolorwhenfocus === 'doc') {
    baseClass = 'ifms-primary-button doc';
  } else {
      baseClass = 'ifms-primary-button';
  }

  return (
    <IfmsButton ref={ref} {...other} baseClass={baseClass}>
      {children}
    </IfmsButton>
  );
});

PrimaryButton.defaultProps = {
};

PrimaryButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'extrasmall']),
};

export default React.memo(PrimaryButton);

